import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import { meetingApi } from './meeting.api';
import { extractError } from '@/lib/axios';

/**
 * Enters a meeting room: runs the join flow (creates the Participant record and
 * returns its id), then navigates to the room with that participant id —
 * which the room needs to fetch a LiveKit token.
 */
export function useEnterMeeting() {
  const navigate = useNavigate();

  return useCallback(
    async (meeting: { id: string; meetingCode: string }, opts: { password?: string } = {}) => {
      try {
        const res = await meetingApi.join(meeting.meetingCode, { password: opts.password });
        const waiting = res.waiting ? '&waiting=1' : '';
        navigate(`/meeting/${meeting.id}?participant=${res.participant.id}${waiting}`);
      } catch (err) {
        toast.error(extractError(err).message);
      }
    },
    [navigate],
  );
}
